import { Alert, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import type { OperationResult, OperationStatus } from '@/shared/api/operationResult'

/**
 * `OperationResult` → antd `Alert` turi.
 *
 * ⚠️ `PARTIAL` SARIQ, qizil ham yashil ham EMAS — bu butun jadvaldagi
 * yagona muhim qator (`shared/api/operationResult.ts`, `CLAUDE.md`
 * §3.2 Qoida 4). Baza YANGILANDI, faqat faol sessiyaga qo'llanmadi.
 * Qizil ko'rsatish operatorni amalni QAYTA bajarishga undaydi (baza esa
 * to'g'ri), yashil ko'rsatish esa YOLG'ON — abonent hali ham eski
 * tezlikda ishlayapti.
 */
const ALERT_TYPE: Record<OperationStatus, 'success' | 'warning' | 'error'> = {
  OK: 'success',
  PARTIAL: 'warning',
  FAILED: 'error',
}

const TITLE_KEY: Record<OperationStatus, string> = {
  OK: 'operation.okTitle',
  PARTIAL: 'operation.partialTitle',
  FAILED: 'operation.failedTitle',
}

interface OperationResultAlertProps {
  result: OperationResult | null
  onClose?: () => void
}

/**
 * Boshqaruv amalining natijasi.
 *
 * <h2>⚠️ NEGA `features/cashdesk/CashFeedbackAlert` QAYTA ISHLATILMADI</h2>
 * `features/*` bir-birini import qilmaydi (07-FRONTEND.md §6), lekin
 * sabab shundagina emas: u BOSHQA narsani chizadi. Kassa banneri pul
 * amalining to'rt «tovushi» ustida ishlaydi (`refused` — server aniq
 * rad javobi, `partial` — pul ko'chdi, yon ta'sir bo'lmadi) va
 * ularning hech biri serverning `OperationResult` maydoniga to'g'ri
 * kelmaydi. Bu yerda esa kontrakt aynan serverdan keladi: uch holat,
 * uchtasi ham HTTP 200.
 *
 * Shuning uchun fayl `shared/ui/` da: u `shared/api/operationResult.ts`
 * ning YAGONA ko'rinishi va keyingi ekran uchun ham shu qoladi.
 *
 * ⚠️ `detail` (CoA javobi, xato kodi) YIG'ILGAN emas, KICHIK yozuvda
 * chiqadi: u ko'pincha «nega qo'llanmadi» degan yagona javobni
 * tashiydi, «Batafsil» tugmasi esa uni hech kim ochmaydigan joyga
 * yashirardi.
 */
export function OperationResultAlert({ result, onClose }: OperationResultAlertProps) {
  const { t } = useTranslation()
  if (!result) return null

  return (
    <Alert
      type={ALERT_TYPE[result.status]}
      showIcon
      closable={onClose !== undefined}
      {...(onClose ? { onClose } : {})}
      message={t(TITLE_KEY[result.status])}
      description={
        <>
          <div>{result.message}</div>
          {result.detail ? (
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
              {result.detail}
            </Typography.Text>
          ) : null}
        </>
      }
    />
  )
}
